import { Component, OnInit } from '@angular/core';
import { LayoutService } from "../../layout/layout.service";
import { environment } from "@env/environment";

@Component({
  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  public user: any;
  public userProfileDetails: any = JSON;
  public profilePhoto;

  constructor(private layoutService: LayoutService) {
    this.userProfileDetails.userName = localStorage.getEncryptedItem('firstName') + ' ' + localStorage.getEncryptedItem('name');
  }
  ngOnInit() {

     let profileImage = localStorage.getEncryptedItem('profileImage') ? environment.NETGATE_URL+localStorage.getEncryptedItem('profileImage'): 'assets/img/avatars/male.png';

      this.profilePhoto = profileImage + '?' + new Date().getTime();
      this.sendLoginInfo(this.profilePhoto)
 
  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }

  sendLoginInfo(profilephoto){
    this.layoutService.publishProfilePhoto(profilephoto);
  }
}
